// Native
import { Box, Grid, GridItem, HStack, Stack, Text } from "@chakra-ui/react"

// Custom
import { Form, Parts, UI } from "components"
import useUser from "hooks/useUser"

export default function Profile(){

    const user = useUser()

    return(
    <>
    <UI.Header title="Perfil" />

    <Grid templateColumns={{ lg: '1fr 2fr', md: '1fr 1fr', sm: '1fr' }} gap={4} mt={4} pr={2}>

        <GridItem>

            {/* Profile */}
            <Parts.Widgets.Profile.Indication />

        </GridItem>

        <GridItem>
            <Stack gap={4}>
                <Parts.Widgets.Profile.Personal />
                <Parts.Widgets.Profile.Contact />
                <Parts.Widgets.Profile.Address />
                <Parts.Widgets.Profile.Password />
            </Stack>
                

            
        </GridItem>

    </Grid>

    <Box p={6}>
        
    </Box>
    </>
    )
}